import useSWR from "swr";
import { getTranslates, createTranslate, updateTranslate, TTranslate } from "@/api";

export const useGroupTranslates = (group: string) => {
  const { data, error, isLoading, mutate } = useSWR<TTranslate[]>(
    ["translates", group],
    () => getTranslates({ group })
  );

  const upsertTranslate = async (name: string, lang: string, value: string) => {
    const existing = data?.find((t) => t.name === name && t.lang === lang);
    if (existing) {
      await updateTranslate(existing.id, { value });
    } else {
      await createTranslate({ group, name, value, lang });
    }
    await mutate();
  };

  return {
    items: data ?? [],
    error,
    isLoading,
    mutate,
    upsertTranslate,
  };
};

export const useSupplierPermissionTranslations = (key?: string) => {
  const group = "supplier-permissions";
  const { items, error, isLoading, mutate, upsertTranslate } = useGroupTranslates(
    group
  );

  const baseName = key ?? "";
  const nameEs = items.find(
    (t) => t.name === `${baseName}.name` && t.lang === "es"
  )?.value;
  const nameEn = items.find(
    (t) => t.name === `${baseName}.name` && t.lang === "en"
  )?.value;
  const descriptionEs = items.find(
    (t) => t.name === `${baseName}.description` && t.lang === "es"
  )?.value;
  const descriptionEn = items.find(
    (t) => t.name === `${baseName}.description` && t.lang === "en"
  )?.value;

  const setTranslations = async (values: {
    nameEs: string;
    nameEn: string;
    descriptionEs: string;
    descriptionEn: string;
  }) => {
    if (!key) return;
    await Promise.all([
      upsertTranslate(`${key}.name`, "es", values.nameEs),
      upsertTranslate(`${key}.name`, "en", values.nameEn),
      upsertTranslate(`${key}.description`, "es", values.descriptionEs),
      upsertTranslate(`${key}.description`, "en", values.descriptionEn),
    ]);
  };

  return {
    values: {
      nameEs: nameEs ?? "",
      nameEn: nameEn ?? "",
      descriptionEs: descriptionEs ?? "",
      descriptionEn: descriptionEn ?? "",
    },
    isLoading,
    error,
    mutate,
    setTranslations,
    upsertTranslate,
  };
};


